var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1280"
    }
  }, [_c('v-row', {
    staticClass: "mt-4 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("재고관리")])]), _c('v-spacer')], 1), _vm.ready ? _c('giftcard-stock', {
    attrs: {
      "giftcard": _vm.giftcard
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }